import { Icon } from '@iconify/react';
import React from 'react';

export const NotificationIcons = () => {
  const authRole = localStorage.getItem('role');

  const IconTypes: any = {
    'Charge Off': (
      <Icon
        icon='ri:battery-2-charge-line'
        style={{ color: '#e80712', width: '31', height: '31' }}
      />
    ),
    'Charge On': (
      <Icon
        icon='ri:battery-2-charge-line'
        style={{ color: '#1df50a', width: '31', height: '31' }}
      />
    ),
    'Fence In': (
      <Icon
        icon='material-symbols:alarm'
        style={{ color: '#232326', width: '31', height: '31' }}
      />
    ),
    'Fence Out': (
      <Icon
        icon='tdesign:alarm-off-filled'
        style={{ color: '#232326', width: '31', height: '31' }}
      />
    ),

    'Harsh Acceleration': (
      <Icon
        icon='mdi:car-brake-temperature'
        width='31'
        height='31'
        style={{ color: '#f91616' }}
      />
    ),
    'Harsh Braking': (
      <Icon
        icon='mdi:car-brake-alert'
        style={{ color: '#36b234', width: '31', height: '31' }}
      />
    ),
    'Harsh Cornering': (
      <Icon
        icon='mdi:car-brake-fluid-level'
        style={{ color: ' #36b234', width: '31', height: '31' }}
      />
    ),
    'Ignition Off': (
      <Icon
        icon='basil:power-button-solid'
        style={{ color: '#f20a1d', width: '31', height: '31' }}
      />
    ),
    'Ignition On': (
      <Icon
        icon='basil:power-button-solid'
        style={{ color: '#36b234', width: '31', height: '31' }}
      />
    ),
    'Low Battery Alarm': (
      <Icon
        icon='game-icons:ringing-alarm'
        style={{ color: '#045f7a', width: '31', height: '31' }}
      />
    ),
    'Motion Start': (
      <Icon icon='mdi:engine' style={{ color: '#7a2904', width: '31', height: '31' }} />
    ),
    'Motion Stop': (
      <Icon
        icon='mdi:engine-off'
        style={{ color: '#7a2904', width: '31', height: '31' }}
      />
    ),
    'Geofence Added': (
      <Icon icon='wpf:geofence' style={{ color: '#cf081c', width: '31', height: '31' }} />
    ),
    Offline: (
      <Icon icon='nrk:offline' style={{ color: '#eb0924', width: '31', height: '31' }} />
    ),
    'Offline to Online': (
      <Icon
        icon='material-symbols:wifi'
        style={{ color: '#36b234', width: '31', height: '31' }}
      />
    ),
    'OverSpeed End': (
      <Icon
        icon='ion:speedometer'
        style={{ color: '#b8840b', width: '31', height: '31' }}
      />
    ),
    'OverSpeed Start': (
      <Icon
        icon='ion:speedometer'
        style={{ color: '#b8840b', width: '31', height: '31' }}
      />
    ),
    'Power Cut': (
      <Icon
        icon='pepicons-pop:power-circle-filled'
        style={{ color: '#eb0924', width: '31', height: '31' }}
      />
    ),
    Sos: (
      <Icon
        icon='ic:baseline-bus-alert'
        style={{ color: '#36b234', width: '31', height: '31' }}
      />
    ),
    'Trip Start': (
      <Icon icon='bx:trip' width='31' height='31' style={{ color: '#36b234' }} />
    ),
    'Trip End': (
      <Icon icon='bx:trip' width='31' height='31' style={{ color: ' #eb0924' }} />
    ),
    'Towing Start': (
      <Icon
        icon='material-symbols-light:auto-towing'
        width='31'
        height='31'
        style={{ color: '#36b234' }}
      />
    ),
    'Towing End': (
      <Icon
        icon='material-symbols-light:auto-towing'
        width='31'
        height='31'
        style={{ color: '#eb0924' }}
      />
    ),
    'Unauthorized Driver': (
      <Icon
        icon='mdi:user-help'
        style={{ color: '#262223', width: '31', height: '31' }}
      />
    ),
    'Authorized Driver': (
      <Icon icon='mdi:account-secure' width='31' height='31' style={{ color: '#000' }} />
    ),
    'OverSpeed Update': (
      <Icon
        icon='material-symbols-light:speed-rounded'
        style={{ color: '#0ac71a', width: '31', height: '31' }}
      />
    ),
    others: <Icon icon='material-symbols:no-transfer' width='24' height='24' />
  };

  const Events = [
    {
      eventName: 'All',
      Icon: (
        <Icon
          icon='iconamoon:profile-fill'
          style={{ color: '#000', width: '26', height: '26' }}
        />
      ),
      active: true,
      eventType: 'All'
    },
    ...(authRole === 'ROLE_DT_ADMIN'
      ? [
          {
            eventName: 'Authorized Driver',
            Icon: (
              <Icon
                icon='mdi:account-secure'
                width='26'
                height='26'
                style={{ color: '#000' }}
              />
            ),
            active: false,
            eventType: 'Authorized Driver'
          }
        ]
      : []),

    {
      eventName: 'Charge Off',
      Icon: (
        <Icon
          icon='ri:battery-2-charge-line'
          style={{ color: '#e80712', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Charge Off'
    },
    {
      eventName: 'Charge On',
      Icon: (
        <Icon
          icon='ri:battery-2-charge-line'
          style={{ color: '#1df50a', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Charge On'
    },
    {
      eventName: 'Fence In Alarm',
      Icon: (
        <Icon
          icon='material-symbols:alarm'
          style={{ color: '#232326', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Fence In'
    },
    {
      eventName: 'Fence Out Alarm',
      Icon: (
        <Icon
          icon='tdesign:alarm-off-filled'
          style={{ color: '#232326', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Fence Out'
    },

    // {
    //   eventName: 'GeoFence Update',
    //   Icon: (
    //     <Icon
    //       icon='material-symbols:move-location'
    //       style={{ color: '#6d0ac4', width: '26', height: '26' }}
    //     />
    //   ),
    //   active: false,
    //   eventType: 'Geofence Update'
    // },
    {
      eventName: 'Harsh Acceleration',
      Icon: (
        <Icon
          icon='mdi:car-brake-temperature'
          width='24'
          height='24'
          style={{ color: '#f91616' }}
        />
      ),
      active: false,
      eventType: 'Harsh Acceleration'
    },
    {
      eventName: 'Harsh Braking Alarm',
      Icon: (
        <Icon
          icon='mdi:car-brake-alert'
          style={{ color: '#36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Harsh Braking'
    },
    {
      eventName: 'Harsh Cornering Alarm',
      Icon: (
        <Icon
          icon='mdi:car-brake-fluid-level'
          style={{ color: ' #36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Harsh Cornering'
    },
    {
      eventName: 'Ignition Off',
      Icon: (
        <Icon
          icon='basil:power-button-solid'
          style={{ color: '#f20a1d', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Ignition Off'
    },
    {
      eventName: 'Ignition On',
      Icon: (
        <Icon
          icon='basil:power-button-solid'
          style={{ color: '#36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Ignition On'
    },
    {
      eventName: 'Low Battery Alarm',
      Icon: (
        <Icon
          icon='game-icons:ringing-alarm'
          style={{ color: '#045f7a', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Low Battery Alarm'
    },
    {
      eventName: 'Motion Start',
      Icon: (
        <Icon icon='mdi:engine' style={{ color: '#7a2904', width: '26', height: '26' }} />
      ),
      active: false,
      eventType: 'Motion Start'
    },
    {
      eventName: 'Motion Stop',
      Icon: (
        <Icon
          icon='mdi:engine-off'
          style={{ color: '#7a2904', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Motion Stop'
    },
    {
      eventName: 'Offline Alarm',
      Icon: (
        <Icon
          icon='nrk:offline'
          style={{ color: '#eb0924', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Offline'
    },
    {
      eventName: 'Offline To Online Alarm',
      Icon: (
        <Icon
          icon='material-symbols:wifi'
          style={{ color: '#36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Offline to Online'
    },

    {
      eventName: 'OverSpeed End',
      Icon: (
        <Icon
          icon='ion:speedometer'
          style={{ color: '#b8840b', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'OverSpeed End'
    },
    {
      eventName: 'OverSpeed Start',
      Icon: (
        <Icon
          icon='ion:speedometer'
          style={{ color: '#b8840b', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'OverSpeed Start'
    },
    {
      eventName: 'Power Cut Alarm',
      Icon: (
        <Icon
          icon='pepicons-pop:power-circle-filled'
          style={{ color: '#eb0924', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Power Cut'
    },
    // {
    //   eventName: 'OverSpeed Update',
    //   Icon: (
    //     <Icon
    //       icon='material-symbols-light:speed-rounded'
    //       style={{ color: '#0ac71a', width: '26', height: '26' }}
    //     />
    //   ),
    //   active: false,
    //   eventType: 'OverSpeed Update'
    // },

    {
      eventName: 'SOS',
      Icon: (
        <Icon
          icon='ic:baseline-bus-alert'
          style={{ color: '#36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Sos'
    },
    {
      eventName: 'Towing Start',
      Icon: (
        <Icon
          icon='material-symbols-light:auto-towing'
          style={{ color: '#36b234', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Towing Start'
    },
    {
      eventName: 'Towing End',
      Icon: (
        <Icon
          icon='material-symbols-light:auto-towing'
          style={{ color: '#eb0924', width: '26', height: '26' }}
        />
      ),
      active: false,
      eventType: 'Towing End'
    },
    {
      eventName: 'Trip Start',
      Icon: (
        <Icon icon='bx:trip' style={{ color: '#36b234', width: '26', height: '26' }} />
      ),
      active: false,
      eventType: 'Trip Start'
    },
    {
      eventName: 'Trip End',
      Icon: (
        <Icon icon='bx:trip' style={{ color: '#eb0924', width: '26', height: '26' }} />
      ),
      active: false,
      eventType: 'Trip End'
    },
    ...(authRole === 'ROLE_DT_ADMIN'
      ? [
          {
            eventName: 'Unauthorized Driver',
            Icon: (
              <Icon
                icon='mdi:user-help'
                style={{ color: '#262223', width: '26', height: '26' }}
              />
            ),
            active: false,
            eventType: 'Unauthorized Driver'
          },
          {
            eventName: 'Unknown Driver',
            Icon: (
              <Icon
                icon='mdi:user-off'
                style={{ color: '#09077d', width: '26', height: '26' }}
              />
            ),
            active: false,
            eventType: 'Unknown Driver'
          }
        ]
      : [])
  ];

  return {
    IconTypes,
    Events
  };
};
